import React from 'react';

export const Plus = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      stroke="black"
      strokeWidth="1.5"
      x1="11.5803"
      x2="11.5803"
      y1="1.8952"
      y2="21.5745"
    />
    <path d="M21.5396 11.7348H1.86037" stroke="black" strokeWidth="1.5" />
  </svg>
);
